<template>
  <!-- 报警看板 -->
  <div class="monitor-container container-view" ref="pageView">
    <!-- title -->
    <section class="title-section">
      <p class="titleInfo fl">{{ curTime }}</p>
      <p class="titleText"></p>
    </section>
    <section
      class="main"
      v-loading="loading"
      element-loading-background="rgba(0, 0, 0, 0.7)"
    >
      <!-- Top Left -->
      <div class="chartPanel-child topLeft">
        <ul class="chartPanel-child-slide">
          <li
            v-for="(item, index) in topLeftTimelineData"
            :key="item"
            :class="{ active: index === topLeftTimelineActiveIndex }"
            @click="chartInstanceTimelineProgressChange('topLeft', index)"
          >
            {{ item }}
          </li>
        </ul>
        <div class="chartPanel-child-legend">
          <div class="this-year">
            <span class="sign board1"></span>
            <span class="title">{{ thisYear }}年指数</span>
          </div>
          <div class="last-year">
            <span class="sign board1"></span
            ><span class="title">{{ thisYear - 1 }}年同期指数</span>
          </div>
        </div>
        <div class="chartPanel-child-chartArea" ref="topLeftChartDOM"></div>
      </div>

      <!-- Top Right -->
      <div class="chartPanel-child topRight">
        <ul class="chartPanel-child-slide">
          <li
            v-for="(item, index) in topRightTimelineData"
            :key="item"
            :class="{ active: index === topRightTimelineActiveIndex }"
            @click="chartInstanceTimelineProgressChange('topRight', index)"
          >
            {{ item }}
          </li>
        </ul>
        <div class="chartPanel-child-legend">
          <div class="this-year">
            <span class="sign board2"></span>
            <span class="title">{{ thisYear }}年指数</span>
          </div>
          <div class="last-year">
            <span class="sign board2"></span
            ><span class="title">{{ thisYear - 1 }}年同期指数</span>
          </div>
        </div>
        <div class="chartPanel-child-chartArea" ref="topRightChartDOM"></div>
      </div>

      <!-- Bottom Left -->
      <div class="chartPanel-child bottomLeft">
        <ul class="chartPanel-child-slide">
          <li
            v-for="(item, index) in bottomLeftTimelineData"
            :key="item"
            :class="{ active: index === bottomLeftTimelineActiveIndex }"
            @click="chartInstanceTimelineProgressChange('bottomLeft', index)"
          >
            {{ item }}
          </li>
        </ul>
        <div class="chartPanel-child-legend">
          <div class="this-year">
            <span class="sign board3"></span>
            <span class="title">{{ thisYear }}年指数</span>
          </div>
          <div class="last-year">
            <span class="sign board3"></span
            ><span class="title">{{ thisYear - 1 }}年同期指数</span>
          </div>
        </div>
        <div class="chartPanel-child-chartArea" ref="bottomLeftChartDOM"></div>
      </div>

      <!-- Bottom Rgiht -->
      <div class="chartPanel-child bottomRight">
        <ul class="chartPanel-child-slide">
          <li
            v-for="(item, index) in bottomRightTimelineData"
            :key="item"
            :class="{ active: index === bottomRightTimelineActiveIndex }"
            @click="chartInstanceTimelineProgressChange('bottomRight', index)"
          >
            {{ item }}
          </li>
        </ul>
        <div class="chartPanel-child-legend">
          <div class="this-year">
            <span class="sign board4"></span>
            <span class="title">{{ thisYear }}年指数</span>
          </div>
          <div class="last-year">
            <span class="sign board4"></span
            ><span class="title">{{ thisYear - 1 }}年同期指数</span>
          </div>
        </div>
        <div class="chartPanel-child-chartArea" ref="bottomRightChartDOM"></div>
      </div>
    </section>
  </div>
</template>

<script>
// Plugin
import moment from "moment";
import Echarts from "echarts";
import { mapGetters, mapMutations } from "vuex";

// interface
// import {
//   FetchTopLeftChartData,
//   FetchTopRightChartData,
//   FetchBottomLeftChartData,
//   FetchBottomRightChartData
// } from "@/api/emergencyManage/vehicleBoard";

import { findByTypeIndexBoard } from "@/api/emergencyManage/company";

// mixins
import resizeListener from "_private/mixins/resizeListener";

// charts setting

export default {
  mixins: [resizeListener],
  data() {
    return {
      curTime: moment().format("YYYY-MM-DD HH:mm:ss"),
      thisYear: moment().format("YYYY"),
      timeInterval: null, // 时间显示定时器
      resizeTimer: null, // resize事件节流timer
      clientWidth: document.documentElement.clientWidth, // 页面宽度
      clientHeight: document.documentElement.clientHeight, // 页面高度
      reloadDataTime: 1000 * 60 * 60, // 刷新数据时间间隔
      loading: false,

      /*********** topLeft ********************/
      topLeftChartInstance: null, // 左下角图表实例
      topLeftLoading: false, // 左下角数据正在加载
      topLeftChartData: {
        dayData: [],
        monthData: []
      },
      topLeftTimelineData: ["日", "月"],
      topLeftTimelineActiveIndex: 0,

      /*********** topRight ********************/
      topRightChartInstance: null, // 左下角图表实例
      topRightLoading: false, // 左下角数据正在加载
      topRightChartData: {
        dayData: [],
        monthData: []
      },
      topRightTimelineData: ["日", "月"],
      topRightTimelineActiveIndex: 0,

      /*********** bottomLeft ********************/
      bottomLeftChartInstance: null, // 左下角图表实例
      bottomLeftLoading: false, // 左下角数据正在加载
      bottomLeftChartData: {
        dayData: [],
        monthData: []
      },
      bottomLeftTimelineData: ["日", "月"],
      bottomLeftTimelineActiveIndex: 0,

      /*********** bottomRight ********************/
      bottomRightChartInstance: null, // 左下角图表实例
      bottomRightLoading: false, // 左下角数据正在加载
      bottomRightChartData: {
        dayData: [],
        monthData: []
      },
      bottomRightTimelineData: ["日", "月"],
      bottomRightTimelineActiveIndex: 0
    };
  },

  created() {
    !this.isFullScreen && this.updateFullScreen();
  },

  mounted() {
    this.init(); // 初始化中间地图geo数据，获取业务数据
    this.setCLockTimeInterval(); // 时间定时器
  },

  beforeDestroy() {
    clearInterval(this.timeInterval); // 清除定时器
    clearInterval(this.mapChartHighlightTimer);
  },

  computed: {
    ...mapGetters(["isFullScreen"])
  },

  methods: {
    ...mapMutations(["updateFullScreen"]),

    // 设置左上角钟表定时器
    setCLockTimeInterval() {
      clearInterval(this.timeInterval);
      // 设置定时器，每个1秒获取一次时间信息
      this.timeInterval = setInterval(() => {
        this.curTime = moment().format("YYYY-MM-DD HH:mm:ss");
      }, 1000);
    },

    // 监控浏览器及元素变化
    resizeListener() {
      clearTimeout(this.resizeTimer);

      this.resizeTimer = setTimeout(() => {
        this.$nextTick(() => {
          this.clientWidth = document.documentElement.clientWidth;
          this.clientHeight = document.documentElement.clientHeight;

          this.topLeftChartInstance && this.topLeftChartInstance.resize();
          this.topRightChartInstance && this.topRightChartInstance.resize();
          this.bottomLeftChartInstance && this.bottomLeftChartInstance.resize();
          this.bottomCenterChartInstance &&
            this.bottomCenterChartInstance.resize();
          this.bottomRightChartInstance &&
            this.bottomRightChartInstance.resize();
          this.mapChartInstance && this.mapChartInstance.resize();
        });
      }, 300);
    },

    /************************** centerMap ************************************/
    // 初始化中间地图geo数据，获取业务数据
    async init() {
      try {
        this.loading = true;
        let board1 = {
          dayData: [],
          monthData: []
        };

        let board2 = {
          dayData: [],
          monthData: []
        };

        let board3 = {
          dayData: [],
          monthData: []
        };

        let board4 = {
          dayData: [],
          monthData: []
        };

        let { code: code1, result: res } = await findByTypeIndexBoard({
          dayAndMonthFlag: 1
        });
        let { code: code2, result: res2 } = await findByTypeIndexBoard({
          dayAndMonthFlag: 2
        });

        if (
          code1 === 1 &&
          Array.isArray(res["2019"]) &&
          Array.isArray(res["2020"])
        ) {
          res["2020"].forEach(item => {
            res["2019"].forEach(list => {
              if (item.date === list.date) {
                board1.dayData.push({
                  time: item.date,
                  thisYear: item.vehicleActivityIndex,
                  lastYear: list.vehicleActivityIndex
                });

                board2.dayData.push({
                  time: item.date,
                  thisYear: item.averageDailyRunIndex,
                  lastYear: list.averageDailyRunIndex
                });

                board3.dayData.push({
                  time: item.date,
                  thisYear: item.averageDailyMileageIndex,
                  lastYear: list.averageDailyMileageIndex
                });

                board4.dayData.push({
                  time: item.date,
                  thisYear: item.coldChainRiskIndex,
                  lastYear: list.coldChainRiskIndex
                });
              }
            });
          });
        }

        if (
          code2 === 1 &&
          Array.isArray(res2["2019"]) &&
          Array.isArray(res2["2020"])
        ) {
          res2["2020"].forEach(item => {
            res2["2019"].forEach(list => {
              if (item.month === list.month) {
                board1.monthData.push({
                  time: item.month,
                  thisYear: item.vehicleActivityIndex,
                  lastYear: list.vehicleActivityIndex
                });

                board2.monthData.push({
                  time: item.month,
                  thisYear: item.averageDailyRunIndex,
                  lastYear: list.averageDailyRunIndex
                });

                board3.monthData.push({
                  time: item.month,
                  thisYear: item.averageDailyMileageIndex,
                  lastYear: list.averageDailyMileageIndex
                });

                board4.monthData.push({
                  time: item.month,
                  thisYear: item.coldChainRiskIndex,
                  lastYear: list.coldChainRiskIndex
                });
              }
            });
          });
        }

        this.topLeftChartData = board1;
        this.topRightChartData = board2;
        this.bottomLeftChartData = board3;
        this.bottomRightChartData = board4;

        this.initTopLeftChart();
        this.initTopRightChart();
        this.initBottomLeftChart();
        this.initBottomRightChart();
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }

      // 获取地图业务数据
      // this.fetchTopLeftData();
      // this.fetchTopRightData();
      // this.fetchBottomLeftData();
      // this.fetchBottomRightData();
    },

    /************************** Top Left ************************************/
    initTopLeftChart() {
      if (this.topLeftChartInstance) {
        this.topLeftChartInstance.clear();
      } else {
        this.topLeftChartInstance = Echarts.init(this.$refs.topLeftChartDOM);
        this.topLeftChartInstance.on("timelinechanged", ({ currentIndex }) => {
          this.topLeftTimelineActiveIndex = currentIndex;
        });
      }

      const DATA_LENGTH = this.topLeftChartData.dayData.length || 0;
      const options = [
        {
          dataset: {
            source: this.topLeftChartData.dayData,
            dimensions: ["time", "thisYear", "lastYear"]
          },
          series: [
            {
              type: "line",
              name: "日",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [0, 138, 255],
                    [67, 72, 255]
                  )
              },
              lineStyle: {
                color: "#4054f4"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(0, 138, 255, .5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(67, 72, 255, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#008aff" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#4348ff" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            },
            {
              type: "line",
              name: "日",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [0, 138, 255],
                    [67, 72, 255]
                  )
              },
              lineStyle: {
                color: "#4054f4",
                type: "dotted"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(0, 138, 255, .5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(67, 72, 255, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#008aff" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#4348ff" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  },
                  opacity: 0.8
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            }
          ]
        },
        {
          dataset: {
            source: this.topLeftChartData.monthData,
            dimensions: ["time", "thisYear", "lastYear"]
          },
          series: [
            {
              name: "月",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [0, 138, 255],
                    [67, 72, 255]
                  )
              },
              lineStyle: {
                color: "#4054f4"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(0, 138, 255, .5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(67, 72, 255, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#008aff" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#4348ff" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            },
            {
              name: "月",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [0, 138, 255],
                    [67, 72, 255]
                  )
              },
              lineStyle: {
                color: "#4054f4",
                type: "dotted"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(0, 138, 255, .5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(67, 72, 255, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#008aff" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#4348ff" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  },
                  opacity: 0.8
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            }
          ]
        }
      ];
      this.topLeftChartInstance.setOption({
        baseOption: {
          title: {
            text: "冷藏车活跃指数",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(16),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          tooltip: {
            // show: true,
            // formatter: data => {
            //   console.log(data);
            // }
          },
          grid: {
            top: this.calcYDirectionSizeByPercent(90),
            right: this.calcXDirectionSizeByPercent(20),
            bottom: this.calcYDirectionSizeByPercent(39),
            left: this.calcXDirectionSizeByPercent(50)
          },

          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 30,
            data: this.topLeftTimelineData
          },
          xAxis: {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#7b89dc",
                opacity: 0.4
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(8),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false
            },
            lineStyle: {
              color: "#7b89dc",
              opacity: 0.4
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(5),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          series: [
            {
              type: "line",
              symbol: "circle",
              smooth: true,
              symbolSize: this.calcXDirectionSizeByPercent(6),
              label: {
                show: false
              },
              barWidth: this.calcYDirectionSizeByPercent(15)
            },
            {
              type: "line",
              symbol: "circle",
              smooth: true,
              symbolSize: 0,
              label: {
                show: false
              },
              barWidth: this.calcYDirectionSizeByPercent(15)
            }
          ]
        },
        options
      });
    },

    /************************** Top Right ************************************/
    // fetchTopRightData() {
    //   this.topRightLoading = true;
    //   FetchTopRightChartData()
    //     .then(({ code, result, message }) => {
    //       if (code === 1 && result) {
    //         result = {
    //           dayData: [
    //             { time: "9.1", count: 243, num: 100 },
    //             { time: "9.4", count: 331, num: 100 },
    //             { time: "9.7", count: 435, num: 100 },
    //             { time: "9.10", count: 273, num: 100 },
    //             { time: "9.13", count: 288, num: 100 },
    //             { time: "9.16", count: 326, num: 100 },
    //             { time: "9.19", count: 251, num: 100 }
    //           ],
    //           monthData: [
    //             { time: "2", count: 343, num: 10 },
    //             { time: "2", count: 331, num: 20 },
    //             { time: "4", count: 233, num: 30 },
    //             { time: "5", count: 273, num: 40 },
    //             { time: "6", count: 388, num: 50 },
    //             { time: "7", count: 326, num: 60 },
    //             { time: "8", count: 231, num: 70 }
    //           ]
    //         };
    //         this.topRightChartData = result;
    //       } else {
    //         this.errorMessage(
    //           message || "获取车/仓/柜近7日报警数量统计数据失败"
    //         );
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       this.errorMessage("获取车/仓/柜近7日报警数量统计数据失败");
    //     })
    //     .finally(() => {
    //       this.topRightLoading = false;
    //       this.initTopRightChart();
    //     });
    // },

    initTopRightChart() {
      if (this.topRightChartInstance) {
        this.topRightChartInstance.clear();
      } else {
        this.topRightChartInstance = Echarts.init(this.$refs.topRightChartDOM);
        this.topRightChartInstance.on("timelinechanged", ({ currentIndex }) => {
          this.topRightTimelineActiveIndex = currentIndex;
        });
      }

      const DATA_LENGTH = this.topRightChartData.dayData.length || 0;
      const options = [
        {
          dataset: {
            source: this.topRightChartData.dayData,
            dimensions: ["time", "thisYear", "lastYear"]
          },
          series: [
            {
              name: "日",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [63, 238, 212],
                    [0, 161, 76]
                  )
              },
              lineStyle: {
                color: "#33dfba"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(63,238,212,.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(0,161,76,0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#3feed4" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#00a14c" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            },
            {
              name: "日",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [175, 163, 245],
                    [105, 85, 255]
                  )
              },
              lineStyle: {
                color: "#35d2b9",
                type: "dotted"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(63,238,212,.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(63,238,212,0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#3feed4" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#00a14c" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            }
          ]
        },
        {
          dataset: {
            source: this.topRightChartData.monthData,
            dimensions: ["time", "thisYear", "lastYear"]
          },
          series: [
            {
              name: "月",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [63, 238, 212],
                    [0, 161, 76]
                  )
              },
              lineStyle: {
                color: "#33dfba"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(63,238,212,.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(0,161,76,0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#3feed4" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#00a14c" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            },
            {
              name: "月",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [241, 187, 75],
                    [215, 107, 21]
                  )
              },
              lineStyle: {
                color: "#35d2b9",
                type: "dotted"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(63,238,212,.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(63,238,212,0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#3feed4" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#00a14c" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            }
          ]
        }
      ];
      this.topRightChartInstance.setOption({
        baseOption: {
          title: {
            text: "日均运行时长指数",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(16),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },
            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          tooltip: {},
          grid: {
            top: this.calcYDirectionSizeByPercent(90),
            right: this.calcXDirectionSizeByPercent(20),
            bottom: this.calcYDirectionSizeByPercent(39),
            left: this.calcXDirectionSizeByPercent(50)
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 30,
            data: this.topRightTimelineData
          },
          xAxis: {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#7b89dc",
                opacity: 0.4
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(8),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false
            },
            lineStyle: {
              color: "#7b89dc",
              opacity: 0.4
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(5),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          series: [
            {
              type: "line",
              symbol: "circle",
              smooth: true,
              symbolSize: this.calcXDirectionSizeByPercent(6),
              label: {
                show: false
              },
              barWidth: this.calcYDirectionSizeByPercent(15)
            },
            {
              type: "line",
              symbol: "circle",
              smooth: true,
              symbolSize: 0,
              label: {
                show: false
              },
              barWidth: this.calcYDirectionSizeByPercent(15)
            }
          ]
        },
        options
      });
    },

    /************************** Bottom Left ************************************/
    // 获取车/仓/柜近7日报警数量统计数据
    // fetchBottomLeftData() {
    //   this.bottomLeftLoading = true;
    //   FetchBottomLeftChartData()
    //     .then(({ code, result, message }) => {
    //       if (code === 1 && result) {
    //         result = {
    //           dayData: [
    //             { time: "9.1", count: 243, num: 100 },
    //             { time: "9.4", count: 331, num: 100 },
    //             { time: "9.7", count: 435, num: 100 },
    //             { time: "9.10", count: 273, num: 100 },
    //             { time: "9.13", count: 288, num: 100 },
    //             { time: "9.16", count: 326, num: 100 },
    //             { time: "9.19", count: 251, num: 100 }
    //           ],
    //           monthData: [
    //             { time: "9.1", count: 343, num: 10 },
    //             { time: "9.4", count: 331, num: 20 },
    //             { time: "9.7", count: 233, num: 30 },
    //             { time: "9.10", count: 273, num: 40 },
    //             { time: "9.13", count: 388, num: 50 },
    //             { time: "9.16", count: 326, num: 60 },
    //             { time: "9.19", count: 231, num: 70 }
    //           ]
    //         };
    //         this.bottomLeftChartData = result;
    //       } else {
    //         this.errorMessage(
    //           message || "获取车/仓/柜近7日报警数量统计数据失败"
    //         );
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       this.errorMessage("获取车/仓/柜近7日报警数量统计数据失败");
    //     })
    //     .finally(() => {
    //       this.bottomLeftLoading = false;
    //       this.initBottomLeftChart();
    //     });
    // },

    // 初始化底部左侧图表
    initBottomLeftChart() {
      if (this.bottomLeftChartInstance) {
        this.bottomLeftChartInstance.clear();
      } else {
        this.bottomLeftChartInstance = Echarts.init(
          this.$refs.bottomLeftChartDOM
        );
        this.bottomLeftChartInstance.on(
          "timelinechanged",
          ({ currentIndex }) => {
            this.bottomLeftTimelineActiveIndex = currentIndex;
          }
        );
      }

      const DATA_LENGTH = this.bottomLeftChartData.dayData.length || 0;
      const options = [
        {
          dataset: {
            source: this.bottomLeftChartData.dayData,
            dimensions: ["time", "thisYear", "lastYear"]
          },
          series: [
            {
              type: "line",
              name: "日",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [175, 163, 245],
                    [105, 85, 255]
                  )
              },
              lineStyle: {
                color: "#8777fb"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(175, 163, 245, 0.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(105, 85, 255, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#afa3f5" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#6955ff" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            },
            {
              name: "日",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [175, 163, 245],
                    [105, 85, 255]
                  )
              },
              lineStyle: {
                color: "#9789f7",
                type: "dotted"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(175, 163, 245, 0.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(105, 85, 255, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#afa3f5" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#6955ff" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            }
          ]
        },
        {
          dataset: {
            source: this.bottomLeftChartData.monthData,
            dimensions: ["time", "thisYear", "lastYear"]
          },
          series: [
            {
              name: "月",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [175, 163, 245],
                    [105, 85, 255]
                  )
              },
              lineStyle: {
                color: "#8777fb"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(175, 163, 245, 0.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(105, 85, 255, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#afa3f5" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#6955ff" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            },
            {
              name: "月",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [241, 187, 75],
                    [215, 107, 21]
                  )
              },
              lineStyle: {
                color: "#9789f7",
                type: "dotted"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(175, 163, 245, 0.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(105, 85, 255, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#afa3f5" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#6955ff" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            }
          ]
        }
      ];
      this.bottomLeftChartInstance.setOption({
        baseOption: {
          title: {
            text: "日均行驶里程指数",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(16),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },

            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          tooltip: {},
          grid: {
            top: this.calcYDirectionSizeByPercent(90),
            right: this.calcXDirectionSizeByPercent(20),
            bottom: this.calcYDirectionSizeByPercent(39),
            left: this.calcXDirectionSizeByPercent(50)
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 30,
            data: this.bottomLeftTimelineData
          },
          xAxis: {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#7b89dc",
                opacity: 0.4
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(8),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false
            },
            lineStyle: {
              color: "#7b89dc",
              opacity: 0.4
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(5),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          series: [
            {
              type: "line",
              symbol: "circle",
              smooth: true,
              symbolSize: this.calcXDirectionSizeByPercent(6),
              label: {
                show: false
              },
              barWidth: this.calcYDirectionSizeByPercent(15)
            },
            {
              type: "line",
              symbol: "circle",
              smooth: true,
              symbolSize: 0,
              label: {
                show: false
              },
              barWidth: this.calcYDirectionSizeByPercent(15)
            }
          ]
        },
        options
      });
    },

    /************************** Bottom Right ************************************/
    // fetchBottomRightData() {
    //   this.bottomRightLoading = true;
    //   FetchBottomRightChartData()
    //     .then(({ code, result, message }) => {
    //       if (code === 1 && result) {
    //         result = {
    //           dayData: [
    //             { time: "9.1", count: 243, num: 100 },
    //             { time: "9.4", count: 331, num: 100 },
    //             { time: "9.7", count: 435, num: 100 },
    //             { time: "9.10", count: 273, num: 100 },
    //             { time: "9.13", count: 288, num: 100 },
    //             { time: "9.16", count: 326, num: 100 },
    //             { time: "9.19", count: 251, num: 100 }
    //           ],
    //           monthData: [
    //             { time: "9.1", count: 343, num: 10 },
    //             { time: "9.4", count: 331, num: 20 },
    //             { time: "9.7", count: 233, num: 30 },
    //             { time: "9.10", count: 273, num: 40 },
    //             { time: "9.13", count: 388, num: 50 },
    //             { time: "9.16", count: 326, num: 60 },
    //             { time: "9.19", count: 231, num: 70 }
    //           ]
    //         };
    //         this.bottomRightChartData = result;
    //       } else {
    //         this.errorMessage(
    //           message || "获取车/仓/柜近7日报警数量统计数据失败"
    //         );
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err);
    //       this.errorMessage("获取车/仓/柜近7日报警数量统计数据失败");
    //     })
    //     .finally(() => {
    //       this.bottomRightLoading = false;
    //       this.initBottomRightChart();
    //     });
    // },

    initBottomRightChart() {
      if (this.bottomRightChartInstance) {
        this.bottomRightChartInstance.clear();
      } else {
        this.bottomRightChartInstance = Echarts.init(
          this.$refs.bottomRightChartDOM
        );
        this.bottomRightChartInstance.on(
          "timelinechanged",
          ({ currentIndex }) => {
            this.bottomRightTimelineActiveIndex = currentIndex;
          }
        );
      }

      const DATA_LENGTH = this.bottomRightChartData.dayData.length || 0;
      const options = [
        {
          dataset: {
            source: this.bottomRightChartData.dayData,
            dimensions: ["time", "thisYear", "lastYear"]
          },
          series: [
            {
              type: "line",
              name: "日",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [233, 143, 108],
                    [243, 51, 0]
                  )
              },
              lineStyle: {
                color: "#ea8762"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(233, 143, 108, 0.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(243, 51, 0, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#e98f6c" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#f33300" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            },
            {
              type: "line",
              name: "日",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [175, 163, 245],
                    [105, 85, 255]
                  )
              },
              lineStyle: {
                color: "#e97c57",
                type: "dotted"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(233, 143, 108, 0.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(243, 51, 0, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#e98f6c" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#f33300" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            }
          ]
        },
        {
          dataset: {
            source: this.bottomRightChartData.monthData,
            dimensions: ["time", "thisYear", "lastYear"]
          },
          series: [
            {
              name: "月",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [233, 143, 108],
                    [243, 51, 0]
                  )
              },
              lineStyle: {
                color: "#ea8762"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(233, 143, 108, 0.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(243, 51, 0, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#e98f6c" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#f33300" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            },
            {
              name: "月",
              itemStyle: {
                color: item =>
                  this.calcGradualChangeColor(
                    item.dataIndex,
                    DATA_LENGTH,
                    [241, 187, 75],
                    [215, 107, 21]
                  )
              },
              lineStyle: {
                color: "#e97c57",
                type: "dotted"
              },
              areaStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(233, 143, 108, 0.5)" // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(243, 51, 0, 0)" // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              },
              markPoint: {
                itemStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "#e98f6c" // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "#f33300" // 100% 处的颜色
                      }
                    ],
                    global: false // 缺省为 false
                  }
                },
                data: [
                  {
                    type: "max",
                    name: "最大值"
                  }
                ]
              }
            }
          ]
        }
      ];
      this.bottomRightChartInstance.setOption({
        baseOption: {
          title: {
            text: "冷链断链风险指数",
            textStyle: {
              color: "#bad7ff",
              fontSize: this.calcXDirectionSizeByPercent(16),
              lineHeight: this.calcYDirectionSizeByPercent(30)
            },

            padding: [
              this.calcYDirectionSizeByPercent(2),
              this.calcXDirectionSizeByPercent(0),
              0,
              this.calcXDirectionSizeByPercent(10)
            ]
          },
          tooltip: {
            show: true
          },
          grid: {
            top: this.calcYDirectionSizeByPercent(90),
            right: this.calcXDirectionSizeByPercent(20),
            bottom: this.calcYDirectionSizeByPercent(39),
            left: this.calcXDirectionSizeByPercent(50)
          },
          timeline: {
            show: false,
            autoPlay: true,
            loop: true,
            axisType: "category",
            playInterval: 1e3 * 30,
            data: this.bottomRightChartData
          },
          xAxis: {
            type: "category",
            axisLine: {
              lineStyle: {
                color: "#7b89dc",
                opacity: 0.4
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(8),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          yAxis: {
            type: "value",
            min: 0,
            axisTick: {
              show: false
            },
            lineStyle: {
              color: "#7b89dc",
              opacity: 0.4
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              margin: this.calcYDirectionSizeByPercent(5),
              color: "rgba(255, 255, 255, 0.4)",
              fontSize: this.calcXDirectionSizeByPercent(12)
            }
          },
          series: [
            {
              type: "line",
              symbol: "circle",
              smooth: true,
              symbolSize: this.calcXDirectionSizeByPercent(6),
              label: {
                show: false
              },
              barWidth: this.calcYDirectionSizeByPercent(15)
            },
            {
              type: "line",
              symbol: "circle",
              smooth: true,
              symbolSize: 0,
              label: {
                show: false
              },
              barWidth: this.calcYDirectionSizeByPercent(15)
            }
          ]
        },
        options
      });
    },

    // 自动轮播timeline进度更改
    chartInstanceTimelineProgressChange(type, index) {
      let chartInstance = null;
      switch (type) {
        case "topLeft":
          this.topLeftTimelineActiveIndex = index;
          chartInstance = this.topLeftChartInstance;
          break;
        case "topRight":
          this.topRightTimelineActiveIndex = index;
          chartInstance = this.topRightChartInstance;
          break;
        case "bottomLeft":
          this.bottomLeftTimelineActiveIndex = index;
          chartInstance = this.bottomLeftChartInstance;
          break;
        case "bottomRight":
          this.bottomRightTimelineActiveIndex = index;
          chartInstance = this.bottomRightChartInstance;
          break;
      }

      chartInstance &&
        chartInstance.dispatchAction({
          type: "timelineChange",
          currentIndex: index
        });
    },

    // 计算渐变颜色
    calcGradualChangeColor(index, length, startColor, endColor) {
      const rColor =
        startColor[0] + ((endColor[0] - startColor[0]) / length) * index;
      const gColor =
        startColor[1] + ((endColor[1] - startColor[1]) / length) * index;
      const bColor =
        startColor[2] + ((endColor[2] - startColor[2]) / length) * index;

      return `rgb(${rColor}, ${gColor}, ${bColor})`;
    },

    // 计算横向尺寸百分比
    calcXDirectionSizeByPercent(size) {
      return (size / 1920) * this.clientWidth;
    },

    // 计算纵向向尺寸百分比
    calcYDirectionSizeByPercent(size) {
      return (size / 1080) * this.clientHeight;
    }
  }
};
</script>

<style lang="scss" scoped>
@font-face {
  font-family: "LEDNumber";
  src: url(~@/assets/ledFont/LEDNum.eot); /***兼容ie9***/
  src: url(~@/assets/ledFont/LEDNum.eot?#iefix) format("embedded-opentype"),
    /***兼容ie6-ie8***/ url("~@/assets/ledFont/LEDNum.woff") format("woff"),
    local("LEDNum"), url("~@/assets/ledFont/LEDNum.woff"); /***默认使用本地的***/
}

$layout-width: 1920px;
$layout-height: 1080px;

.monitor-container {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #09121b;
  background-image: url("~@/assets/images/alarmBoard/bigScreenBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;

  /*标题*/
  .title-section {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    z-index: 2;
    box-sizing: border-box;
    width: 100%;
    height: 0.83rem;
    padding-top: 0.14rem;
    background-image: url("~@/assets/images/alarmBoard/bigScreenTitleBg.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;

    p {
      margin: 0;
    }

    .titleInfo {
      font-family: "LEDNumber";
      color: #3f83ff;
      font-size: 0.22rem;
      word-spacing: 1em;
      margin-left: 0.35rem;
    }

    .titleText {
      width: 2.6rem;
      height: 0.3rem;
      margin: 0 auto;
      background-image: url("~@/assets/images/emergencyManage/vehicleBoard/title.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center center;
    }
  }

  // 主体
  .main {
    display: flex;
    flex-wrap: wrap;
    position: absolute;
    top: 0.83rem;
    width: 100%;
    height: calc(100% - 0.83rem);
    box-sizing: border-box;

    p {
      margin: 0;
    }

    .chartPanel {
      &-child {
        background-repeat: no-repeat;
        background-size: 100% 100%;

        &.topLeft,
        &.topRight,
        &.bottomLeft,
        &.bottomRight {
          position: relative;
          width: calc(50% - 0.2rem);
          height: calc(50% - 0.2rem);
          margin: 0.1rem;
          box-sizing: border-box;
          background-image: url("~@/assets/images/emergencyManage/vehicleBoard/section-bg.png");
        }

        // &.topLeft {
        //   left: (10px / $layout-width) * 100%;
        //   top: (70px / $layout-height) * 100%;
        //   width: (482px / $layout-width) * 100%;
        //   height: (640px / $layout-height) * 100%;
        //   background-image: url("~@/assets/images/alarmBoard/top_bg.png");
        // }

        // &.topRight {
        //   right: (10px / $layout-width) * 100%;
        //   top: (70px / $layout-height) * 100%;
        //   width: (482px / $layout-width) * 100%;
        //   height: (640px / $layout-height) * 100%;
        //   background-image: url("~@/assets/images/alarmBoard/top_bg.png");
        // }

        // &.bottomLeft {
        //   left: (10px / $layout-width) * 100%;
        //   bottom: (10px / $layout-height) * 100%;
        //   width: (572px / $layout-width) * 100%;
        //   height: (303px / $layout-height) * 100%;
        //   background-image: url("~@/assets/images/alarmBoard/bottom_bg.png");
        // }

        // &.bottomRight {
        //   right: (10px / $layout-width) * 100%;
        //   bottom: (10px / $layout-height) * 100%;
        //   width: (572px / $layout-width) * 100%;
        //   height: (303px / $layout-height) * 100%;
        //   background-image: url("~@/assets/images/alarmBoard/bottom_bg.png");
        // }

        &-slide {
          position: absolute;
          top: 0.07rem;
          right: 0.25rem;
          display: flex;
          z-index: 10;

          li {
            margin-left: 0.03rem;
            padding: 0.05rem 0.06rem;
            font-size: 0.12rem;
            color: #7b89dc;
            transition: all 0.3s;
            cursor: pointer;

            &:hover,
            &.active {
              color: #fff;
              background: #7b89dc;
              border-radius: 0.05rem;
            }
          }
        }

        &-legend {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          height: 0.3rem;
          color: #7b89dc;
          font-size: 0.12rem;

          .sign {
            display: inline-block;
            margin: 0 0.05rem;
            width: 0.16rem;
            vertical-align: middle;
          }

          .this-year {
            margin-right: 0.03rem;
            .sign {
              position: relative;
              height: 2px;

              &.board1 {
                background-color: #095eb7;
              }

              &.board2 {
                background-color: #25cd9a;
              }

              &.board3 {
                background-color: #a99cf6;
              }

              &.board4 {
                background-color: #ee6338;
              }

              &::before {
                content: "";
                display: block;
                width: 6px;
                height: 6px;
                border-radius: 50%;
                position: absolute;
                top: -2px;
                left: 50%;
                transform: translateX(-50%);
              }

              &.board1::before {
                background-color: #095eb7;
              }

              &.board2::before {
                background-color: #25cd9a;
              }

              &.board3::before {
                background-color: #a99cf6;
              }

              &.board4::before {
                background-color: #ee6338;
              }
            }
          }

          .last-year {
            margin-left: 0.03rem;

            .sign {
              border-bottom: 2px dotted;

              &.board1 {
                border-color: #095eb7;
              }

              &.board2 {
                border-color: #25cd9a;
              }

              &.board3 {
                border-color: #a99cf6;
              }

              &.board4 {
                border-color: #ee6338;
              }
            }
          }
        }

        &-chartArea {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
